import apiRequest from './api-request';

const resource = 'tenant-updates';

export function getTenantUpdates() {
    return apiRequest({
        method: 'GET',
        resource
    });
}

export function setTenantUpdatesModerated(tenantId: number | string) {
    return apiRequest({
        method: 'PUT',
        resource: `tenants/${tenantId}/updates-moderated`,
        body: {}
    });
}
